import { TranslationsContext } from '@teliaee/telia-translate';
import { Footer, IFooterSocialMediaItem } from 'telia-front-react';
import React from 'react';
import { inject, observer } from 'mobx-react';

import config from '../config';
import MenuStore from '../stores/MenuStore';
import { capitalizeFirstLetter } from '../util/TextUtil';

interface FooterContainerProps {
  menuStore?: MenuStore;
  app?: App;
}

@observer
class FooterContainer extends React.Component<FooterContainerProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  private getSocialMediaItems(): IFooterSocialMediaItem[] {
    const { app } = this.props;
    const translate = this.context.translate;
    const { facebookUrl, instagramUrl, tikTokUrl } = config[app];

    if (app === 'super') {
      return [
        {
          url: facebookUrl,
          label: translate('facebook.label'),
          icon: '#facebook'
        },
        {
          url: instagramUrl as string,
          label: translate('instagram.label'),
          icon: '#instagram'
        },
        {
          url: tikTokUrl as string,
          label: translate('tiktok.label'),
          icon: '#logo-tiktok'
        }
      ];
    }

    return [
      {
        url: facebookUrl,
        label: translate('facebook.label'),
        icon: '#facebook'
      }
    ];
  }

  private getFooter() {
    const { app } = this.props;
    const { translate } = this.context;

    if (app === 'super') {
      return [
        {
          content: translate('footer.trademark'),
          className: 'text-weight-normal'
        }
      ];
    }
  }

  public render() {
    const { app } = this.props;
    return (
      <Footer
        color={app === 'super' ? 'neutral' : 'brand'}
        logo={{ text: capitalizeFirstLetter(this.props.app) }}
        socialMediaItems={this.getSocialMediaItems()}
        bottomLinks={this.props.menuStore.footerNav()}
        footer={this.getFooter()}
      />
    );
  }
}

export default inject('menuStore', 'app')(FooterContainer);
